<div class="wrapper">
  <div class="selected-container">
    <app-checkbox
      class="checkbox"
      [isReadOnly]="true"
      [ngModel]="true"
      [checkBoxVariant]="'multiselect'"
      [checkboxType]="'tertiary'"
      (click)="$event.stopPropagation()"
    ></app-checkbox>

    <span data-test-id="selected-count-label" class="selected-count-label font-main">
      {{ selectedCountTranslationKey | translate: { count: selectedCount } }}
    </span>

    <app-new-button
      class="select-all-button"
      [type]="'basic'"
      [class.hidden]="isAllSelected"
      (click)="selectAll()"
    >
      {{ buildTranslationKey('selectAllBtn') | translate }}
    </app-new-button>
  </div>

  <div class="actions-container">
    <ng-content></ng-content>

    <span class="vertical-line"></span>

    <app-icon-button
      class="close-button"
      [svgIconPath]="'close-thin'"
      [type]="'basic'"
      (click)="unSelectAll()"
    ></app-icon-button>
  </div>
</div>
